<template>

    <div id="lock-months">
      <div class="content-wrapper">
        <div class="page-heading">
            <h1 class="page-title">{{$t('message.lockMonths')}}</h1>
            <div class="page-content fade-in-up">
               <div class="row">
                    <div class="col-md-12">
                          <div class="ibox">
                                <div class="ibox-body"> 
                                   <div class="tab-pane fade active show">
                                     <div class="go-back" @click="goBack">
                                          <i style="padding: 3px" class="fa fa-arrow-left"></i>
                                          <span class="backToButton" style="padding: 3px; ">{{$t('message.backToProjectPage')}}</span>
                          
                                      </div>

                                    <div class="row">

                                        <ul :style="gridStyle" class="card-list">
                                            <li v-for="(projectMonth, index) in projectMonths" class="card-item" :key="index">
                                              {{ removeDayFromDate(projectMonth.month) }}
                                              <label class="switch">
                                                <input type="checkbox" v-model="projectMonth.lock" @change="updateLockedMonths(projectMonth)">
                                                <span class="slider"></span>
                                              </label>
                                            </li>
                                          </ul>

                                    </div>

                                   </div> 
                                </div> 
                          </div>  
                    </div>
                    
                </div>
                  
            </div>
        </div>  
      </div> 
    </div>
</template>

<script>

import OkModal from '../../../modals/OkModal'

export default {
    name: 'LockMonths',
    components: {
      
    },
    data(){
      return {
         projectMonths : [],
         numberOfColumns: 6,

      }
    },
     computed: {
      gridStyle() {
        return {
          gridTemplateColumns: `repeat(${this.numberOfColumns}, minmax(100px, 1fr))`
        }
      },
    },
    created(){
    
       this.setArrayProjectMonths(this.$route.params["start_date"], this.$route.params["end_date"])
       this.getList(this.apiPrefix, this.projectApiUrl+'get-locked-months/', this.$route.params['id'])
        .then(resp => {

            for(let i=0; i<resp.data.length; i++){
                for(let j= 0; j < this.projectMonths.length; j++) {
                  if (this.projectMonths[j].month === resp.data[i]) {
                     this.projectMonths[j].lock=true
                      break;
                  }
              }
            }
        })
        .catch(err => {
          console.log(err.response)
        })
    },
    methods: {
      setArrayProjectMonths (startDate, stopDate) {

        let currentDate = this.$moment(startDate);
        let endDate = this.$moment(stopDate);
          while (currentDate < endDate) {     
              this.projectMonths.push( { month: this.$moment(currentDate).format('YYYY-MM-DD'), lock: false })
              currentDate = this.$moment(currentDate).add(1, 'months');
          }  

      },
      goBack () {
        this.$router.push({name: 'EditProject', params: {id: this.$route.params["id"]}})
      },
      updateLockedMonths(projectMonth){

        this.update(this.apiPrefix, this.costsBudgetApiUrl + 'lock-unlock-per-month/', this.$route.params["id"], {
          month: projectMonth.month,
          lock: projectMonth.lock
        })
            .then(res => {
              console.log(res)
            }).catch(err => {
            console.log(err.response)
            this.$modal.show(OkModal, {
                text: this.$t('message.oopsSomethingWentWrong'),
                modalClass: this.modalClasses.okErrorClass
              },
              {
                width: this.modalWidth(),
                height: 'auto'
              })
          })

      }
     
    },
  }
  
</script>

<style scoped>
  
.card-list {
  display: grid;
  grid-gap: 1em;
  
}

.card-item {
  padding: 2em;
  border-radius: 7px;
  font-size: 21px;
  height: 30px;
  vertical-align : middle;
}

@media screen and (max-width: 1405px) {
    .card-item {
        font-size: 14px;
        padding-bottom: 12px;
        padding-left: 12px;
    }

    .switch {
      padding-top: 5px;
    }
}


ul {
  list-style-type: none;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}



.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

</style>
